const stockholmCountyMunicipalities = [
    {name_swe: "Upplands Väsby", namefi: "Upplands Väsby", name_eng: "Upplands Väsby"},
    {name_swe: "Vallentuna", namefi: "Vallentuna", name_eng: "Vallentuna"},
    {name_swe: "Österåker", namefi: "Österåker", name_eng: "Österåker"},
    {name_swe: "Värmdö", namefi: "Värmdö", name_eng: "Värmdö"},
    {name_swe: "Järfälla", namefi: "Järfälla", name_eng: "Järfälla"},
    {name_swe: "Ekerö", namefi: "Ekerö", name_eng: "Ekerö"},
    {name_swe: "Huddinge", namefi: "Huddinge", name_eng: "Huddinge"},
    {name_swe: "Botkyrka", namefi: "Botkyrka", name_eng: "Botkyrka"},
    {name_swe: "Salem", namefi: "Salem", name_eng: "Salem"},
    {name_swe: "Haninge", namefi: "Haninge", name_eng: "Haninge"},
    {name_swe: "Tyresö", namefi: "Tyresö", name_eng: "Tyresö"},
    {name_swe: "Upplands-Bro", namefi: "Upplands-Bro", name_eng: "Upplands-Bro"},
    {name_swe: "Nykvarn", namefi: "Nykvarn", name_eng: "Nykvarn"},
    {name_swe: "Täby", namefi: "Täby", name_eng: "Täby"},
    {name_swe: "Danderyd", namefi: "Danderyd", name_eng: "Danderyd"},
    {name_swe: "Sollentuna", namefi: "Sollentuna", name_eng: "Sollentuna"},
    {name_swe: "Stockholm", namefi: "Stockholm", name_eng: "Stockholm"},
    {name_swe: "Södertälje", namefi: "Södertälje", name_eng: "Södertälje"},
    {name_swe: "Nacka", namefi: "Nacka", name_eng: "Nacka"},
    {name_swe: "Sundbyberg", namefi: "Sundbyberg", name_eng: "Sundbyberg"},
    {name_swe: "Solna", namefi: "Solna", name_eng: "Solna"},
    {name_swe: "Lidingö", namefi: "Lidingö", name_eng: "Lidingö"},
    {name_swe: "Vaxholm", namefi: "Vaxholm", name_eng: "Vaxholm"},
    {name_swe: "Norrtälje", namefi: "Norrtälje", name_eng: "Norrtälje"},
    {name_swe: "Sigtuna", namefi: "Sigtuna", name_eng: "Sigtuna"},
    {name_swe: "Nynäshamn", namefi: "Nynäshamn", name_eng: "Nynäshamn"},
]

const uppsalaCountyMunicipalities = [
    {name_swe: "Håbo", namefi: "Håbo", name_eng: "Håbo"},
    {name_swe: "Älvkarleby", namefi: "Älvkarleby", name_eng: "Älvkarleby"},
    {name_swe: "Knivsta", namefi: "Knivsta", name_eng: "Knivsta"},
    {name_swe: "Heby", namefi: "Heby", name_eng: "Heby"},
    {name_swe: "Tierp", namefi: "Tierp", name_eng: "Tierp"},
    {name_swe: "Uppsala", namefi: "Uppsala", name_eng: "Uppsala"},
    {name_swe: "Enköping", namefi: "Enköping", name_eng: "Enköping"},
    {name_swe: "Östhammar", namefi: "Östhammar", name_eng: "Östhammar"},
]
const sodermanlandsCountyMunicipalities = [
    {name_swe: "Vingåker", namefi: "Vingåker", name_eng: "Vingåker"},
    {name_swe: "Gnesta", namefi: "Gnesta", name_eng: "Gnesta"},
    {name_swe: "Nyköping", namefi: "Nyköping", name_eng: "Nyköping"},
    {name_swe: "Oxelösund", namefi: "Oxelösund", name_eng: "Oxelösund"},
    {name_swe: "Flen", namefi: "Flen", name_eng: "Flen"},
    {name_swe: "Katrineholm", namefi: "Katrineholm", name_eng: "Katrineholm"},
    {name_swe: "Eskilstuna", namefi: "Eskilstuna", name_eng: "Eskilstuna"},
    {name_swe: "Strängnäs", namefi: "Strängnäs", name_eng: "Strängnäs"},
    {name_swe: "Trosa", namefi: "Trosa", name_eng: "Trosa"},
]
const ostergotlandsCountyMunicipalities = [
    {name_swe: "Ödeshög", namefi: "Ödeshög", name_eng: "Ödeshög"},
    {name_swe: "Ydre", namefi: "Ydre", name_eng: "Ydre"},
    {name_swe: "Kinda", namefi: "Kinda", name_eng: "Kinda"},
    {name_swe: "Boxholm", namefi: "Boxholm", name_eng: "Boxholm"},
    {name_swe: "Åtvidaberg", namefi: "Åtvidaberg", name_eng: "Åtvidaberg"},
    {name_swe: "Finspång", namefi: "Finspång", name_eng: "Finspång"},
    {name_swe: "Valdemarsvik", namefi: "Valdemarsvik", name_eng: "Valdemarsvik"},
    {name_swe: "Linköping", namefi: "Linköping", name_eng: "Linköping"},
    {name_swe: "Norrköping", namefi: "Norrköping", name_eng: "Norrköping"},
    {name_swe: "Söderköping", namefi: "Söderköping", name_eng: "Söderköping"},
    {name_swe: "Motala", namefi: "Motala", name_eng: "Motala"},
    {name_swe: "Vadstena", namefi: "Vadstena", name_eng: "Vadstena"},
    {name_swe: "Mjölby", namefi: "Mjölby", name_eng: "Mjölby"},
]
const jonkopingCountyMunicipalities = [
    {name_swe: "Aneby", namefi: "Aneby", name_eng: "Aneby"},
    {name_swe: "Gnosjö", namefi: "Gnosjö", name_eng: "Gnosjö"},
    {name_swe: "Mullsjö", namefi: "Mullsjö", name_eng: "Mullsjö"},
    {name_swe: "Habo", namefi: "Habo", name_eng: "Habo"},
    {name_swe: "Gislaved", namefi: "Gislaved", name_eng: "Gislaved"},
    {name_swe: "Vaggeryd", namefi: "Vaggeryd", name_eng: "Vaggeryd"},
    {name_swe: "Jönköping", namefi: "Jönköping", name_eng: "Jönköping"},
    {name_swe: "Nässjö", namefi: "Nässjö", name_eng: "Nässjö"},
    {name_swe: "Värnamo", namefi: "Värnamo", name_eng: "Värnamo"},
    {name_swe: "Sävsjö", namefi: "Sävsjö", name_eng: "Sävsjö"},
    {name_swe: "Vetlanda", namefi: "Vetlanda", name_eng: "Vetlanda"},
    {name_swe: "Eksjö", namefi: "Eksjö", name_eng: "Eksjö"},
    {name_swe: "Tranås", namefi: "Tranås", name_eng: "Tranås"},
]
const kronobergsCountyMunicipalities = [
    {name_swe: "Uppvidinge", namefi: "Uppvidinge", name_eng: "Uppvidinge"},
    {name_swe: "Lessebo", namefi: "Lessebo", name_eng: "Lessebo"},
    {name_swe: "Tingsryd", namefi: "Tingsryd", name_eng: "Tingsryd"},
    {name_swe: "Alvesta", namefi: "Alvesta", name_eng: "Alvesta"},
    {name_swe: "Älmhult", namefi: "Älmhult", name_eng: "Älmhult"},
    {name_swe: "Markaryd", namefi: "Markaryd", name_eng: "Markaryd"},
    {name_swe: "Växjö", namefi: "Växjö", name_eng: "Växjö"},
    {name_swe: "Ljungby", namefi: "Ljungby", name_eng: "Ljungby"},
]
const kalmarCountyMunicipalities = [
    {name_swe: "Högsby", namefi: "Högsby", name_eng: "Högsby"},
    {name_swe: "Torsås", namefi: "Torsås", name_eng: "Torsås"},
    {name_swe: "Mörbylånga", namefi: "Mörbylånga", name_eng: "Mörbylånga"},
    {name_swe: "Hultsfred", namefi: "Hultsfred", name_eng: "Hultsfred"},
    {name_swe: "Mönsterås", namefi: "Mönsterås", name_eng: "Mönsterås"},
    {name_swe: "Emmaboda", namefi: "Emmaboda", name_eng: "Emmaboda"},
    {name_swe: "Kalmar", namefi: "Kalmar", name_eng: "Kalmar"},
    {name_swe: "Nybro", namefi: "Nybro", name_eng: "Nybro"},
    {name_swe: "Oskarshamn", namefi: "Oskarshamn", name_eng: "Oskarshamn"},
    {name_swe: "Västervik", namefi: "Västervik", name_eng: "Västervik"},
    {name_swe: "Vimmerby", namefi: "Vimmerby", name_eng: "Vimmerby"},
    {name_swe: "Borgholm", namefi: "Borgholm", name_eng: "Borgholm"},
]
const gotlandsCountyMunicipalities = [
    {name_swe: "Gotland", namefi: "Gotland", name_eng: "Gotland"}
]
const blekingeCountyMunicipalities = [
    {name_swe: "Olofström", namefi: "Olofström", name_eng: "Olofström"},
    {name_swe: "Karlskrona", namefi: "Karlskrona", name_eng: "Karlskrona"},
    {name_swe: "Ronneby", namefi: "Ronneby", name_eng: "Ronneby"},
    {name_swe: "Karlshamn", namefi: "Karlshamn", name_eng: "Karlshamn"},
    {name_swe: "Sölvesborg", namefi: "Sölvesborg", name_eng: "Sölvesborg"},
]
const skaneCountyMunicipalities = [
    {name_swe: "Svalöv", namefi: "Svalöv", name_eng: "Svalöv"},
    {name_swe: "Staffanstorp", namefi: "Staffanstorp", name_eng: "Staffanstorp"},
    {name_swe: "Burlöv", namefi: "Burlöv", name_eng: "Burlöv"},
    {name_swe: "Vellinge", namefi: "Vellinge", name_eng: "Vellinge"},
    {name_swe: "Östra Göinge", namefi: "Östra Göinge", name_eng: "Östra Göinge"},
    {name_swe: "Örkelljunga", namefi: "Örkelljunga", name_eng: "Örkelljunga"},
    {name_swe: "Bjuv", namefi: "Bjuv", name_eng: "Bjuv"},
    {name_swe: "Kävlinge", namefi: "Kävlinge", name_eng: "Kävlinge"},
    {name_swe: "Lomma", namefi: "Lomma", name_eng: "Lomma"},
    {name_swe: "Svedala", namefi: "Svedala", name_eng: "Svedala"},
    {name_swe: "Skurup", namefi: "Skurup", name_eng: "Skurup"},
    {name_swe: "Sjöbo", namefi: "Sjöbo", name_eng: "Sjöbo"},
    {name_swe: "Hörby", namefi: "Hörby", name_eng: "Hörby"},
    {name_swe: "Höör", namefi: "Höör", name_eng: "Höör"},
    {name_swe: "Tomelilla", namefi: "Tomelilla", name_eng: "Tomelilla"},
    {name_swe: "Bromölla", namefi: "Bromölla", name_eng: "Bromölla"},
    {name_swe: "Osby", namefi: "Osby", name_eng: "Osby"},
    {name_swe: "Perstorp", namefi: "Perstorp", name_eng: "Perstorp"},
    {name_swe: "Klippan", namefi: "Klippan", name_eng: "Klippan"},
    {name_swe: "Åstorp", namefi: "Åstorp", name_eng: "Åstorp"},
    {name_swe: "Båstad", namefi: "Båstad", name_eng: "Båstad"},
    {name_swe: "Malmö", namefi: "Malmö", name_eng: "Malmö"},
    {name_swe: "Lund", namefi: "Lund", name_eng: "Lund"},
    {name_swe: "Landskrona", namefi: "Landskrona", name_eng: "Landskrona"},
    {name_swe: "Helsingborg", namefi: "Helsingborg", name_eng: "Helsingborg"},
    {name_swe: "Höganäs", namefi: "Höganäs", name_eng: "Höganäs"},
    {name_swe: "Eslöv", namefi: "Eslöv", name_eng: "Eslöv"},
    {name_swe: "Ystad", namefi: "Ystad", name_eng: "Ystad"},
    {name_swe: "Trelleborg", namefi: "Trelleborg", name_eng: "Trelleborg"},
    {name_swe: "Kristianstad", namefi: "Kristianstad", name_eng: "Kristianstad"},
    {name_swe: "Simrishamn", namefi: "Simrishamn", name_eng: "Simrishamn"},
    {name_swe: "Ängelholm", namefi: "Ängelholm", name_eng: "Ängelholm"},
    {name_swe: "Hässleholm", namefi: "Hässleholm", name_eng: "Hässleholm"},
]
const hallandsCountyMunicipalities = [
    {name_swe: "Hylte", namefi: "Hylte", name_eng: "Hylte"},
    {name_swe: "Halmstad", namefi: "Halmstad", name_eng: "Halmstad"},
    {name_swe: "Laholm", namefi: "Laholm", name_eng: "Laholm"},
    {name_swe: "Falkenberg", namefi: "Falkenberg", name_eng: "Falkenberg"},
    {name_swe: "Varberg", namefi: "Varberg", name_eng: "Varberg"},
    {name_swe: "Kungsbacka", namefi: "Kungsbacka", name_eng: "Kungsbacka"},
]
const vastraGotalandsCountyMunicipalities = [
    {
        name_swe: "Härryda",
        namefi: "Härryda",
        name_eng: "Härryda"
    },
    {
        name_swe: "Partille",
        namefi: "Partille",
        name_eng: "Partille"
    },
    {
        name_swe: "Öckerö",
        namefi: "Öckerö",
        name_eng: "Öckerö"
    },
    {
        name_swe: "Stenungsund",
        namefi: "Stenungsund",
        name_eng: "Stenungsund"
    },
    {
        name_swe: "Tjörn",
        namefi: "Tjörn",
        name_eng: "Tjörn"
    },
    {
        name_swe: "Orust",
        namefi: "Orust",
        name_eng: "Orust"
    },
    {
        name_swe: "Sotenäs",
        namefi: "Sotenäs",
        name_eng: "Sotenäs"
    },
    {
        name_swe: "Munkedal",
        namefi: "Munkedal",
        name_eng: "Munkedal"
    },
    {
        name_swe: "Tanum",
        namefi: "Tanum",
        name_eng: "Tanum"
    },
    {
        name_swe: "Dals-Ed",
        namefi: "Dals-Ed",
        name_eng: "Dals-Ed"
    },
    {
        name_swe: "Färgelanda",
        namefi: "Färgelanda",
        name_eng: "Färgelanda"
    },
    {
        name_swe: "Ale",
        namefi: "Ale",
        name_eng: "Ale"
    },
    {
        name_swe: "Lerum",
        namefi: "Lerum",
        name_eng: "Lerum"
    },
    {
        name_swe: "Vårgårda",
        namefi: "Vårgårda",
        name_eng: "Vårgårda"
    },
    {
        name_swe: "Bollebygd",
        namefi: "Bollebygd",
        name_eng: "Bollebygd"
    },
    {
        name_swe: "Grästorp",
        namefi: "Grästorp",
        name_eng: "Grästorp"
    },
    {
        name_swe: "Essunga",
        namefi: "Essunga",
        name_eng: "Essunga"
    },
    {
        name_swe: "Karlsborg",
        namefi: "Karlsborg",
        name_eng: "Karlsborg"
    },
    {
        name_swe: "Gullspång",
        namefi: "Gullspång",
        name_eng: "Gullspång"
    },
    {
        name_swe: "Tranemo",
        namefi: "Tranemo",
        name_eng: "Tranemo"
    },
    {
        name_swe: "Bengtsfors",
        namefi: "Bengtsfors",
        name_eng: "Bengtsfors"
    },
    {
        name_swe: "Mellerud",
        namefi: "Mellerud",
        name_eng: "Mellerud"
    },
    {
        name_swe: "Lilla Edet",
        namefi: "Lilla Edet",
        name_eng: "Lilla Edet"
    },
    {
        name_swe: "Mark",
        namefi: "Mark",
        name_eng: "Mark"
    },
    {
        name_swe: "Svenljunga",
        namefi: "Svenljunga",
        name_eng: "Svenljunga"
    },
    {
        name_swe: "Herrljunga",
        namefi: "Herrljunga",
        name_eng: "Herrljunga"
    },
    {
        name_swe: "Vara",
        namefi: "Vara",
        name_eng: "Vara"
    },
    {
        name_swe: "Götene",
        namefi: "Götene",
        name_eng: "Götene"
    },
    {
        name_swe: "Tibro",
        namefi: "Tibro",
        name_eng: "Tibro"
    },
    {
        name_swe: "Töreboda",
        namefi: "Töreboda",
        name_eng: "Töreboda"
    },
    {
        name_swe: "Göteborg",
        namefi: "Göteborg",
        name_eng: "Göteborg"
    },
    {
        name_swe: "Mölndal",
        namefi: "Mölndal",
        name_eng: "Mölndal"
    },
    {
        name_swe: "Kungälv",
        namefi: "Kungälv",
        name_eng: "Kungälv"
    },
    {
        name_swe: "Lysekil",
        namefi: "Lysekil",
        name_eng: "Lysekil"
    },
    {
        name_swe: "Uddevalla",
        namefi: "Uddevalla",
        name_eng: "Uddevalla"
    },
    {
        name_swe: "Strömstad",
        namefi: "Strömstad",
        name_eng: "Strömstad"
    },
    {
        name_swe: "Vänersborg",
        namefi: "Vänersborg",
        name_eng: "Vänersborg"
    },
    {
        name_swe: "Trollhättan",
        namefi: "Trollhättan",
        name_eng: "Trollhättan"
    },
    {
        name_swe: "Alingsås",
        namefi: "Alingsås",
        name_eng: "Alingsås"
    },
    {
        name_swe: "Borås",
        namefi: "Borås",
        name_eng: "Borås"
    },
    {
        name_swe: "Ulricehamn",
        namefi: "Ulricehamn",
        name_eng: "Ulricehamn"
    },
    {
        name_swe: "Åmål",
        namefi: "Åmål",
        name_eng: "Åmål"
    },
    {
        name_swe: "Mariestad",
        namefi: "Mariestad",
        name_eng: "Mariestad"
    },
    {
        name_swe: "Lidköping",
        namefi: "Lidköping",
        name_eng: "Lidköping"
    },
    {
        name_swe: "Skara",
        namefi: "Skara",
        name_eng: "Skara"
    },
    {
        name_swe: "Skövde",
        namefi: "Skövde",
        name_eng: "Skövde"
    },
    {
        name_swe: "Hjo",
        namefi: "Hjo",
        name_eng: "Hjo"
    },
    {
        name_swe: "Tidaholm",
        namefi: "Tidaholm",
        name_eng: "Tidaholm"
    },
    {
        name_swe: "Falköping",
        namefi: "Falköping",
        name_eng: "Falköping"
    }
]
const varmlandsCountyMunicipalities = [
    {
        name_swe: "Kil",
        namefi: "Kil",
        name_eng: "Kil"
    },
    {
        name_swe: "Eda",
        namefi: "Eda",
        name_eng: "Eda"
    },
    {
        name_swe: "Torsby",
        namefi: "Torsby",
        name_eng: "Torsby"
    },
    {
        name_swe: "Storfors",
        namefi: "Storfors",
        name_eng: "Storfors"
    },
    {
        name_swe: "Hammarö",
        namefi: "Hammarö",
        name_eng: "Hammarö"
    },
    {
        name_swe: "Munkfors",
        namefi: "Munkfors",
        name_eng: "Munkfors"
    },
    {
        name_swe: "Forshaga",
        namefi: "Forshaga",
        name_eng: "Forshaga"
    },
    {
        name_swe: "Grums",
        namefi: "Grums",
        name_eng: "Grums"
    },
    {
        name_swe: "Årjäng",
        namefi: "Årjäng",
        name_eng: "Årjäng"
    },
    {
        name_swe: "Sunne",
        namefi: "Sunne",
        name_eng: "Sunne"
    },
    {
        name_swe: "Karlstad",
        namefi: "Karlstad",
        name_eng: "Karlstad"
    },
    {
        name_swe: "Kristinehamn",
        namefi: "Kristinehamn",
        name_eng: "Kristinehamn"
    },
    {
        name_swe: "Filipstad",
        namefi: "Filipstad",
        name_eng: "Filipstad"
    },
    {
        name_swe: "Hagfors",
        namefi: "Hagfors",
        name_eng: "Hagfors"
    },
    {
        name_swe: "Arvika",
        namefi: "Arvika",
        name_eng: "Arvika"
    },
    {
        name_swe: "Säffle",
        namefi: "Säffle",
        name_eng: "Säffle"
    }

]
const orebroCountyMunicipalities = [
    {
        name_swe: "Lekeberg",
        namefi: "Lekeberg",
        name_eng: "Lekeberg"
    },
    {
        name_swe: "Laxå",
        namefi: "Laxå",
        name_eng: "Laxå"
    },
    {
        name_swe: "Hallsberg",
        namefi: "Hallsberg",
        name_eng: "Hallsberg"
    },
    {
        name_swe: "Degerfors",
        namefi: "Degerfors",
        name_eng: "Degerfors"
    },
    {
        name_swe: "Hällefors",
        namefi: "Hällefors",
        name_eng: "Hällefors"
    },
    {
        name_swe: "Ljusnarsberg",
        namefi: "Ljusnarsberg",
        name_eng: "Ljusnarsberg"
    },
    {
        name_swe: "Örebro",
        namefi: "Örebro",
        name_eng: "Örebro"
    },
    {
        name_swe: "Kumla",
        namefi: "Kumla",
        name_eng: "Kumla"
    },
    {
        name_swe: "Askersund",
        namefi: "Askersund",
        name_eng: "Askersund"
    },
    {
        name_swe: "Karlskoga",
        namefi: "Karlskoga",
        name_eng: "Karlskoga"
    },
    {
        name_swe: "Nora",
        namefi: "Nora",
        name_eng: "Nora"
    },
    {
        name_swe: "Lindesberg",
        namefi: "Lindesberg",
        name_eng: "Lindesberg"
    }

]
const vastmanlandsCountyMunicipalities = [
    {
        name_swe: "Skinnskatteberg",
        namefi: "Skinnskatteberg",
        name_eng: "Skinnskatteberg"
    },
    {
        name_swe: "Surahammar",
        namefi: "Surahammar",
        name_eng: "Surahammar"
    },
    {
        name_swe: "Kungsör",
        namefi: "Kungsör",
        name_eng: "Kungsör"
    },
    {
        name_swe: "Hallstahammar",
        namefi: "Hallstahammar",
        name_eng: "Hallstahammar"
    },
    {
        name_swe: "Norberg",
        namefi: "Norberg",
        name_eng: "Norberg"
    },
    {
        name_swe: "Västerås",
        namefi: "Västerås",
        name_eng: "Västerås"
    },
    {
        name_swe: "Sala",
        namefi: "Sala",
        name_eng: "Sala"
    },
    {
        name_swe: "Fagersta",
        namefi: "Fagersta",
        name_eng: "Fagersta"
    },
    {
        name_swe: "Köping",
        namefi: "Köping",
        name_eng: "Köping"
    },
    {
        name_swe: "Arboga",
        namefi: "Arboga",
        name_eng: "Arboga"
    }
]
const dalaranasCountyMunicipalities = [
    {
        name_swe: "Vansbro",
        namefi: "Vansbro",
        name_eng: "Vansbro"
    },
    {
        name_swe: "Malung-Sälen",
        namefi: "Malung-Sälen",
        name_eng: "Malung-Sälen"
    },
    {
        name_swe: "Gagnef",
        namefi: "Gagnef",
        name_eng: "Gagnef"
    },
    {
        name_swe: "Leksand",
        namefi: "Leksand",
        name_eng: "Leksand"
    },
    {
        name_swe: "Rättvik",
        namefi: "Rättvik",
        name_eng: "Rättvik"
    },
    {
        name_swe: "Orsa",
        namefi: "Orsa",
        name_eng: "Orsa"
    },
    {
        name_swe: "Älvdalen",
        namefi: "Älvdalen",
        name_eng: "Älvdalen"
    },
    {
        name_swe: "Smedjebacken",
        namefi: "Smedjebacken",
        name_eng: "Smedjebacken"
    },
    {
        name_swe: "Mora",
        namefi: "Mora",
        name_eng: "Mora"
    },
    {
        name_swe: "Falun",
        namefi: "Falun",
        name_eng: "Falun"
    },
    {
        name_swe: "Borlänge",
        namefi: "Borlänge",
        name_eng: "Borlänge"
    },
    {
        name_swe: "Säter",
        namefi: "Säter",
        name_eng: "Säter"
    },
    {
        name_swe: "Hedemora",
        namefi: "Hedemora",
        name_eng: "Hedemora"
    },
    {
        name_swe: "Avesta",
        namefi: "Avesta",
        name_eng: "Avesta"
    },
    {
        name_swe: "Ludvika",
        namefi: "Ludvika",
        name_eng: "Ludvika"
    }
]
const gavleBorgsCountyMunicipalities = [
    {
        name_swe: "Ockelbo",
        namefi: "Ockelbo",
        name_eng: "Ockelbo"
    },
    {
        name_swe: "Hofors",
        namefi: "Hofors",
        name_eng: "Hofors"
    },
    {
        name_swe: "Ovanåker",
        namefi: "Ovanåker",
        name_eng: "Ovanåker"
    },
    {
        name_swe: "Nordanstig",
        namefi: "Nordanstig",
        name_eng: "Nordanstig"
    },
    {
        name_swe: "Ljusdal",
        namefi: "Ljusdal",
        name_eng: "Ljusdal"
    },
    {
        name_swe: "Gävle",
        namefi: "Gävle",
        name_eng: "Gävle"
    },
    {
        name_swe: "Sandviken",
        namefi: "Sandviken",
        name_eng: "Sandviken"
    },
    {
        name_swe: "Söderhamn",
        namefi: "Söderhamn",
        name_eng: "Söderhamn"
    },
    {
        name_swe: "Bollnäs",
        namefi: "Bollnäs",
        name_eng: "Bollnäs"
    },
    {
        name_swe: "Hudiksvall",
        namefi: "Hudiksvall",
        name_eng: "Hudiksvall"
    }
]
const vasternorrlandsCountyMunicipalities = [
    {
        name_swe: "Ånge",
        namefi: "Ånge",
        name_eng: "Ånge"
    },
    {
        name_swe: "Timrå",
        namefi: "Timrå",
        name_eng: "Timrå"
    },
    {
        name_swe: "Härnösand",
        namefi: "Härnösand",
        name_eng: "Härnösand"
    },
    {
        name_swe: "Sundsvall",
        namefi: "Sundsvall",
        name_eng: "Sundsvall"
    },
    {
        name_swe: "Kramfors",
        namefi: "Kramfors",
        name_eng: "Kramfors"
    },
    {
        name_swe: "Sollefteå",
        namefi: "Sollefteå",
        name_eng: "Sollefteå"
    },
    {
        name_swe: "Örnsköldsvik",
        namefi: "Örnsköldsvik",
        name_eng: "Örnsköldsvik"
    }
]
const jamtlandsCountyMunicipalities = [
    {
        name_swe: "Ragunda",
        namefi: "Ragunda",
        name_eng: "Ragunda"
    },
    {
        name_swe: "Bräcke",
        namefi: "Bräcke",
        name_eng: "Bräcke"
    },
    {
        name_swe: "Krokom",
        namefi: "Krokom",
        name_eng: "Krokom"
    },
    {
        name_swe: "Strömsund",
        namefi: "Strömsund",
        name_eng: "Strömsund"
    },
    {
        name_swe: "Åre",
        namefi: "Åre",
        name_eng: "Åre"
    },
    {
        name_swe: "Berg",
        namefi: "Berg",
        name_eng: "Berg"
    },
    {
        name_swe: "Härjedalen",
        namefi: "Härjedalen",
        name_eng: "Härjedalen"
    },
    {
        name_swe: "Östersund",
        namefi: "Östersund",
        name_eng: "Östersund"
    }
]
const vasterbottensCountyMunicipalities = [
    {
        name_swe: "Nordmaling",
        namefi: "Nordmaling",
        name_eng: "Nordmaling"
    },
    {
        name_swe: "Bjurholm",
        namefi: "Bjurholm",
        name_eng: "Bjurholm"
    },
    {
        name_swe: "Vindeln",
        namefi: "Vindeln",
        name_eng: "Vindeln"
    },
    {
        name_swe: "Robertsfors",
        namefi: "Robertsfors",
        name_eng: "Robertsfors"
    },
    {
        name_swe: "Norsjö",
        namefi: "Norsjö",
        name_eng: "Norsjö"
    },
    {
        name_swe: "Malå",
        namefi: "Malå",
        name_eng: "Malå"
    },
    {
        name_swe: "Storuman",
        namefi: "Storuman",
        name_eng: "Storuman"
    },
    {
        name_swe: "Sorsele",
        namefi: "Sorsele",
        name_eng: "Sorsele"
    },
    {
        name_swe: "Dorotea",
        namefi: "Dorotea",
        name_eng: "Dorotea"
    },
    {
        name_swe: "Vännäs",
        namefi: "Vännäs",
        name_eng: "Vännäs"
    },
    {
        name_swe: "Vilhelmina",
        namefi: "Vilhelmina",
        name_eng: "Vilhelmina"
    },
    {
        name_swe: "Åsele",
        namefi: "Åsele",
        name_eng: "Åsele"
    },
    {
        name_swe: "Umeå",
        namefi: "Umeå",
        name_eng: "Umeå"
    },
    {
        name_swe: "Lycksele",
        namefi: "Lycksele",
        name_eng: "Lycksele"
    },
    {
        name_swe: "Skellefteå",
        namefi: "Skellefteå",
        name_eng: "Skellefteå"
    }
]
const norrbottensCountyMunicipalities = [
    {
        name_swe: "Arvidsjaur",
        namefi: "Arvidsjaur",
        name_eng: "Arvidsjaur"
    },
    {
        name_swe: "Arjeplog",
        namefi: "Arjeplog",
        name_eng: "Arjeplog"
    },
    {
        name_swe: "Jokkmokk",
        namefi: "Jokkmokk",
        name_eng: "Jokkmokk"
    },
    {
        name_swe: "Överkalix",
        namefi: "Överkalix",
        name_eng: "Överkalix"
    },
    {
        name_swe: "Kalix",
        namefi: "Kalix",
        name_eng: "Kalix"
    },
    {
        name_swe: "Övertorneå",
        namefi: "Övertorneå",
        name_eng: "Övertorneå"
    },
    {
        name_swe: "Pajala",
        namefi: "Pajala",
        name_eng: "Pajala"
    },
    {
        name_swe: "Gällivare",
        namefi: "Gällivare",
        name_eng: "Gällivare"
    },
    {
        name_swe: "Älvsbyn",
        namefi: "Älvsbyn",
        name_eng: "Älvsbyn"
    },
    {
        name_swe: "Luleå",
        namefi: "Luleå",
        name_eng: "Luleå"
    },
    {
        name_swe: "Piteå",
        namefi: "Piteå",
        name_eng: "Piteå"
    },
    {
        name_swe: "Boden",
        namefi: "Boden",
        name_eng: "Boden"
    },
    {
        name_swe: "Haparanda",
        namefi: "Haparanda",
        name_eng: "Haparanda"
    },
    {
        name_swe: "Kiruna",
        namefi: "Kiruna",
        name_eng: "Kiruna"
    }
]
const swedishMunicipalities = [
    {name_swe: "Stockholms län", municipalities: stockholmCountyMunicipalities},
    {name_swe: "Uppsala län", municipalities: uppsalaCountyMunicipalities},
    {name_swe: "Södermanlands län", municipalities: sodermanlandsCountyMunicipalities},
    {name_swe: "Östergötlands län", municipalities: ostergotlandsCountyMunicipalities},
    {name_swe: "Jönköpings län", municipalities: jonkopingCountyMunicipalities},
    {name_swe: "Kronobergs län", municipalities: kronobergsCountyMunicipalities},
    {name_swe: "Kalmar län", municipalities: kalmarCountyMunicipalities},
    {name_swe: "Gotlands län", municipalities: gotlandsCountyMunicipalities},
    {name_swe: "Blekinge län", municipalities: blekingeCountyMunicipalities},
    {name_swe: "Skåne län", municipalities: skaneCountyMunicipalities},
    {name_swe: "Hallands län", municipalities: hallandsCountyMunicipalities},
    {name_swe: "Västra Götalands län", municipalities: vastraGotalandsCountyMunicipalities},
    {name_swe: "Värmlands län", municipalities: varmlandsCountyMunicipalities},
    {name_swe: "Örebro län", municipalities: orebroCountyMunicipalities},
    {name_swe: "Västmanlands län", municipalities: vastmanlandsCountyMunicipalities},
    {name_swe: "Dalarnas län", municipalities: dalaranasCountyMunicipalities},
    {name_swe: "Gävleborgs län", municipalities: gavleBorgsCountyMunicipalities},
    {name_swe: "Västernorrlands län", municipalities: vasternorrlandsCountyMunicipalities},
    {name_swe: "Jämtlands län", municipalities: jamtlandsCountyMunicipalities},
    {name_swe: "Västerbottens län", municipalities: vasterbottensCountyMunicipalities},
    {name_swe: "Norrbottens län", municipalities: norrbottensCountyMunicipalities},
]
const swedishMunicipalities_OLD = [
    ...stockholmCountyMunicipalities,
    ...uppsalaCountyMunicipalities,
    ...sodermanlandsCountyMunicipalities,
    ...ostergotlandsCountyMunicipalities,
    ...jonkopingCountyMunicipalities,
    ...kronobergsCountyMunicipalities,
    ...kalmarCountyMunicipalities,
    ...gotlandsCountyMunicipalities,
    ...blekingeCountyMunicipalities,
    ...skaneCountyMunicipalities,
    ...hallandsCountyMunicipalities,
    ...vastraGotalandsCountyMunicipalities,
    ...varmlandsCountyMunicipalities,
    ...orebroCountyMunicipalities,
    ...vastmanlandsCountyMunicipalities,
    ...dalaranasCountyMunicipalities,
    ...gavleBorgsCountyMunicipalities,
    ...vasternorrlandsCountyMunicipalities,
    ...vasterbottensCountyMunicipalities,
    ...norrbottensCountyMunicipalities,
]
export {
    swedishMunicipalities,
    dalaranasCountyMunicipalities,
    gavleBorgsCountyMunicipalities,
    gotlandsCountyMunicipalities,
    hallandsCountyMunicipalities,
    jamtlandsCountyMunicipalities,
    jonkopingCountyMunicipalities,
    kalmarCountyMunicipalities,
    kronobergsCountyMunicipalities,
    norrbottensCountyMunicipalities,
    orebroCountyMunicipalities,
    ostergotlandsCountyMunicipalities,
    skaneCountyMunicipalities,
    sodermanlandsCountyMunicipalities,
    stockholmCountyMunicipalities,
    uppsalaCountyMunicipalities,
    varmlandsCountyMunicipalities,
    vasterbottensCountyMunicipalities,
    vasternorrlandsCountyMunicipalities,
    vastmanlandsCountyMunicipalities,
    vastraGotalandsCountyMunicipalities,
    blekingeCountyMunicipalities,
};